/**
 * useNavigation Hook
 * LAYER-SHELL: Role-based navigation filtering
 *
 * Returns ALL navigation items the user's role can access.
 * No portal-based filtering - unified navigation experience.
 */
import { useMemo } from 'react';
import type { UserRole } from '../components/Shell/Shell';
import { getNavigationForRole, type NavItem } from '../config/navigation';

/**
 * Hook to get navigation items for a user role.
 * Returns ALL items the role can access across the entire app.
 * Memoized to prevent unnecessary recalculations.
 *
 * @param role The current user's role
 * @returns Navigation items accessible to that role
 */
export function useNavigation(role: UserRole): NavItem[] {
  return useMemo(() => getNavigationForRole(role), [role]);
}

export default useNavigation;
